
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Mở menu trình duyệt của bạn`,
's182ab2d6c997515f': `Thêm nó vào màn hình chính của bạn để có trải nghiệm phong phú hơn và truy cập dễ dàng hơn.`,
's1b9047d53d9f9d22': `2) Nhấp vào nút "Chia sẻ" trên thanh điều hướng`,
's2d90afa5dcca2c0e': `3) Kéo đến mục "Thêm vào Màn hình chính"`,
's37a9e8aec5713460': `Thêm`,
's4593f304dac8848c': `2) Nhấn vào "Thêm vào Màn hình chính"`,
's54cfbb14f46396d4': `1) Mở trình duyệt chính của bạn`,
's6196153c4b0c1ea0': `Cài đặt`,
's922329d6f6213590': `Thêm vào Dock`,
'sa5ef80b4bb9b39f8': `Thu gọn`,
'sa7551383d1897fcc': `2) Nhấp vào "Thêm vào Dock"`,
'sba52286c21552a4e': `Cài đặt trên thiết bị của bạn để có trải nghiệm phong phú hơn và truy cập dễ dàng.`,
'sc79fd7641eb9a975': `Ẩn các bước cài đặt`,
'scdaf4bbff76674c8': `Thêm vào màn hình chính`,
'se740f75b95a51807': `Thêm nó vào Dock của bạn để có trải nghiệm toàn diện hơn và truy cập dễ dàng hơn.`,
'sfea652f6580ff086': `Trang web này có cả chức năng đặc trưng ứng dụng.`,
    };
  